import { computed } from '@nuxtjs/composition-api';
import { Ref } from '@vue/composition-api';

import buildMetaTags, { IBuildMetaTagsInfo } from '~/helper-functions/meta-tags/buildMetaTags';
import DefaultMetaTags from '~/types/defaultMetaTags';
import { EDefaultMetaTags } from '~/types/EDefaultMetaTags';
import { IRouteInfo } from '~/types/IRouteInfo';

interface IMetaTagService {
  routeInfo: Ref<IRouteInfo>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  route: Ref<any>;
  defaultMetaTags?: DefaultMetaTags;
}

export default function useMetaTagsService(params: IMetaTagService) {
  const { routeInfo, defaultMetaTags } = params;
  const title = computed(() => routeInfo.value?.Meta?.Title);
  const description = computed(() => routeInfo.value?.Meta?.Description);
  // const keyRoute = computed(() => routeInfo.value?.Klucz);
  const sitemapa = computed(() => routeInfo.value?.Sitemapa);

  // const path = computed(() => route.value.fullPath);
  const path = computed(() => routeInfo.value.Route);

  const metaTagInfo: IBuildMetaTagsInfo = {
    title: title.value,
    description: description.value,
    sitemapa: sitemapa.value,
    path: path.value,
    defaultMetaTags: !defaultMetaTags ? EDefaultMetaTags : defaultMetaTags,
  };

  const metaTags = buildMetaTags(metaTagInfo);

  return {
    metaTags,
  };
}
